import { useQueryState } from 'nuqs';
import { useEffect, useState } from 'react';
import { Icon } from '@/components/entities/Sprite';
import { Input } from '@/components/ui/Input/input';
import { cn } from '@/utils/cn';

type GamesSearchBarProps = {
  placeholder: string;
  onChange: (value: string) => void;
  onClear: () => void;
};

export function GamesSearchBar({ placeholder, onChange, onClear }: GamesSearchBarProps) {
  const [isSearchFocused, setIsSearchFocused] = useState(false);
  const [searchValue, setSearchValue] = useQueryState('search', {
    defaultValue: '',
  });

  useEffect(() => {
    onChange(searchValue);
  }, [onChange, searchValue]);

  const handleClear = () => {
    setSearchValue('');
    onClear();
    setIsSearchFocused(false);
  };

  return (
    <div className="absolute right-0 w-full flex justify-end">
      <Input
        placeholder={placeholder}
        value={searchValue}
        onChange={event => setSearchValue(event.target.value)}
        containerClassName={cn('transition-all duration-300 size-10 md:w-[15.625rem]', isSearchFocused && 'w-full')}
        className={cn('pr-0 transition-all duration-300 ml-auto h-10 w-full lg:pl-12', isSearchFocused && 'pl-12')}
        icon={<Icon name="search" className={cn('text-c300 -ml-4 lg:-ml-1', isSearchFocused && ' -ml-2')} />}
        onFocus={() => setIsSearchFocused(true)}
      />

      {searchValue && (
        <button
          onClick={handleClear}
          type="button"
          className="absolute right-3 top-1/2 -translate-y-1/2 z-10 text-violet-c400"
          aria-label="Clear search"
        >
          <Icon name="x_close" className="w-4 h-4" />
        </button>
      )}
    </div>
  );
}
